/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mesafeli_S8_C_Li5Inputs */

const tr_mesafeli_s8_c_li5 = /** @type {(inputs: Mesafeli_S8_C_Li5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pazaryeri API anahtarları ve Müşteri İçeriği ile ilgili olarak KVKK kapsamında veri sorumlusu sıfatını taşımak.`)
};

const en_mesafeli_s8_c_li5 = /** @type {(inputs: Mesafeli_S8_C_Li5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`To bear the status of data controller under KVKK with respect to the marketplace API keys and Customer Content.`)
};

const de_mesafeli_s8_c_li5 = /** @type {(inputs: Mesafeli_S8_C_Li5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In Bezug auf die Marktplatz-API-Schlüssel und die Kundeninhalte im Rahmen des KVKK die Eigenschaft des Verantwortlichen tragen.`)
};

const ru_mesafeli_s8_c_li5 = /** @type {(inputs: Mesafeli_S8_C_Li5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Нести статус оператора персональных данных по KVKK в отношении API-ключей маркетплейсов и Контента Клиента.`)
};

/**
* | output |
* | --- |
* | "To bear the status of data controller under KVKK with respect to the marketplace API keys and Customer Content." |
*
* @param {Mesafeli_S8_C_Li5Inputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const mesafeli_s8_c_li5 = /** @type {((inputs?: Mesafeli_S8_C_Li5Inputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mesafeli_S8_C_Li5Inputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_mesafeli_s8_c_li5(inputs)
	if (locale === "de") return de_mesafeli_s8_c_li5(inputs)
	if (locale === "ru") return ru_mesafeli_s8_c_li5(inputs)
	return tr_mesafeli_s8_c_li5(inputs)
});